<script setup lang="ts">

// Nuxt automatically passes an 'error' prop to this component
const props = defineProps({
  error: Object
})

// Function to clear the error and redirect home
const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <SharedPageContainer class="flex flex-col h-screen">
    <SharedBasicPageHeader />

    <!-- 1. Added 'flex flex-col', 'justify-center', and fixed 'items-center' typo -->
    <div class="flex-1 flex flex-col items-center grid h-96 grid-rows-[1fr_auto_2fr]">
      <div />
      <!-- 2. The green div will now sit perfectly in the middle -->
      <div class="flex flex-col items-center">
        <!-- Dashboard-style Icon Branding -->
        <div class="mb-6 flex h-20 w-20 items-center justify-center">
          <UIcon name="i-heroicons-exclamation-circle" class="h-12 w-12 text-primary bg-error" />
        </div>

        <h1 class="error text-4xl font-bold tracking-tight sm:text-5xl">
          {{ error?.statusCode === 404 ? $t('errors.404_title') : $t('errors.error_occurred_title') }}
        </h1>

        <p class="mt-4 text-base">
          {{ error?.message || "Sorry, we couldn’t find the page you’re looking for." }}
        </p>

        <div class="mt-10 flex items-center justify-center gap-x-6">
          <UButton label="Go back home" size="lg" color="primary" @click="handleError" />
          <UButton label="Contact support" variant="soft" size="lg" color="neutral"
            to="mailto:support@yourdomain.com" />
        </div>
      </div>

    </div>
  </SharedPageContainer>
</template>
